<ng-container *ngIf="state$ | async as state">
       <span class="tw-text-3xl tw-leading-[39px] tw-inline tw-mr-2"
             [innerHTML]="state.product?.nameHtml| safeHtml"
             data-cy="mb-product-headline"
             data-analytics="product-title">
        </span>
    <span *ngIf="state.recombinant" class="tw-leading-4 tw-inline-block md:tw-inline tw-whitespace-nowrap tw-font-sans tw-text-sm tw-px-2 tw-py-0.5 tw-bg-grey-600 tw-text-white tw-rounded-[50rem] tw-font-bold tw-relative tw-top-[-0.25rem] tw-mr-2" data-cy="mb-product-headline-recombinant-stamp">{{'mbproduct.recombinant' | mbTranslate}}</span>
  <ng-container *ngIf="state.validation">
    <span *ngIf="state.validation[0] === '1'" class="tw-leading-4 tw-inline-block md:tw-inline tw-whitespace-nowrap tw-font-sans tw-text-sm tw-px-2 tw-py-0.5 tw-bg-grey-600 tw-text-white tw-rounded-[50rem] tw-font-bold tw-relative tw-top-[-0.25rem]" data-cy="mb-product-headline-validation-stamp">{{'mbproduct.validation' | mbTranslate}}</span>
  </ng-container>
  <div class="tw-mt-2">
    <span *ngIf="state.alternativeNames" class="tw-font-sans-light tw-text-xl tw-italic tw-font-light tw-text-grey-900">{{'mbproduct.synonyms'|mbTranslate}}: {{state.alternativeNames.join(', ')}}</span>
  </div>
    <div class="tw-flex"
         data-cy="pdp-header-rating"
         *ngIf="state.product?.averageRating">
      <cx-star-rating [rating]="state.product?.averageRating"></cx-star-rating>
      <button class="tw-border-none tw-bg-white"
              data-cy="pdp-header-rating-button"
              (click)="showReviews()">
        <div>
          <span>{{ state.product?.numberOfReviews + ' '}}</span>
          <span *ngIf="state.product?.numberOfReviews > 1">{{'mbproduct.reviews' | mbTranslate}}</span>
          <span *ngIf="state.product?.numberOfReviews === 1">{{'mbproduct.review' | mbTranslate}}</span>
        </div>
      </button>
    </div>
</ng-container>

